<!--选择人员-->
<style lang="less">
    .gykj-select-person {

    }
    .gykj-select-person-modal {
        .ivu-modal-body {
            padding: 0;
        }
        .selector-person-wrap {
            .selector-content {
                display: flex;
                .selected-icon{
                    color:#09BB07
                }
                .selector-part {

                    .part-title {
                        padding: 10px;
                        color:#1D1D1D;
                        font-size: 14px;
                        background-color: #fafafb;
                    }
                    .treelist-content {
                        height: 436px;
                        overflow: auto;
                        .tree-item {
                            height: 46px;
                            padding-left: 25px;
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            .tree-item-title {
                                flex: 1;
                            }
                            .tree-item-del{
                              color: #f78e92;
                            }
                            .title-select-chevron {
                                padding-right: 15px;
                            }
                        }
                        .tree-item:hover{
                            background-color: #f0f1f7;
                        }
                    }
                }
                .selector-left {
                    flex: 1;
                    border-right: 1px solid #dce1e8;

                }
                .selector-right {
                    flex: 1;
                }
            }
        }
        .ivu-modal-footer {

        }
    }
</style>
<template>
    <div v-show="visible">
        <Modal v-model="visible" title="选择人员" class="gykj-select-person-modal" width="700">
            <div class="selector-person-wrap">
                <div class="selector-content">
                    <div class="selector-left selector-part">
                        <div class="part-title">选择:</div>
                        <div class="treelist-content">
                            <ul>
                                <li v-for="dep in departments" @click="depSlideDown(dep)">
                                    <div class="tree-item">
                                        <span class="tree-item-title">{{dep.name}}</span>
                                        <span class="title-select-chevron" v-show="!dep.slidDown"><Icon type="chevron-down"></Icon></span>
                                        <span class="title-select-chevron" v-show="dep.slidDown"><Icon type="chevron-up"></Icon></span>
                                    </div>
                                   <transition>
                                        <ul style="padding-left: 15px" v-show="(dep.slidDown && currentQueryDepartment.code == dep.code)">
                                            <li v-for="per in persons">
                                                <div class="tree-item" @click.stop="selectedSingle = per">
                                                  <i class="iconfont " :class="{'icon-weixuanze':selectedSingle.username != per.username,'icon-xuanze selected-icon':selectedSingle.username == per.username}"></i>
                                                  {{per.realname}}
                                                </div>
                                            </li>
                                        </ul>
                                   </transition>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="selector-right selector-part">
                        <div class="part-title">已选:</div>
                        <div class="treelist-content">
                            <ul>
                                <li>
                                    <div class="tree-item" v-show="selectedSingle.realname!=''&& selectedSingle.realname!=undefined">
                                        <span style="padding-right: 10px">{{selectedSingle.realname}}</span>
                                        <span class="tree-item-del" @click="selectedSingle = ''">
                                            <i class="iconfont icon-guanbi2"></i>
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <Button @click="visible = false">取消</Button>
                <Button type="primary" @click="ok">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    
    import { mapState, mapGetters, mapMutations } from "vuex";
    export default {
        props:{
            value: {
                type: Boolean,
                default: false
            },
            currentSelectData:{
                type:Object,
                default (){
                    return {}
                }
            }
        },
        data() {
            return {
                visible: this.value,
                departments:[],
                persons: [],
                selectedSingle:this.currentSelectData,
                currentQueryDepartment:'',
            }
        },
        computed:{
            ...mapState(["user", "department", "token","peopleC"]),
        },
        methods:{
            ok() {
                let data = {username:'',realname:''};
                if(this.selectedSingle!=''&& this.selectedSingle!= undefined){
                    if(this.selectedSingle.username!=''&&  this.selectedSingle.username!=undefined){
                        data.username = this.selectedSingle.username
                    }
                    if(this.selectedSingle.realname!=''&&  this.selectedSingle.realname!=undefined){
                        data.realname = this.selectedSingle.realname
                    }
                }
                this.$emit("on-ok",data);
                this.visible = false;
            },
            //获取部门信息
            getDepartments(){
                let that = this;
                let params = {};
                params.url = '/sys/department/list'
                params.data = {};
                params.token = window.localStorage.getItem("token");
                params.success = function (res) {
                    res = res.data;
                    if (res.code = '0000') {
                        that.departments = res.result.result;
                        that.departments.map((item)=>{
                            that.$set(item,'slidDown',false);
                        })
                    }
                };
                this.ajaxPost(params)
            },
            //根据部门、获取人员
            getPeople:function (dep) {
                let that = this;
                this.persons = [];
                let params = {};
                params.url = '/sys/userinfo/search';
                params.token = window.localStorage.getItem("token");
                params.data ={'department_name':dep.name};
                params.success = function (res) {
                    res = res.data;
                    if (res.code = '0000') {
                        that.persons = res.result.result;
                        console.log("people",that.persons)
                    }
                };
                this.ajaxPost(params)
            },
            //展开部门下的人员
            depSlideDown(dep){
                this.currentQueryDepartment = dep;
                this.$set(dep,'slidDown',!dep.slidDown);
                console.log(dep.slidDown);
                console.log(dep)
                if(dep.slidDown == true){
                    this.getPeople(dep);
                }
            }
        },
        mounted(){
            this.getDepartments()
        },
        watch:{
        	peopleC(){
    			this.getDepartments();
    		},
            value (val) {
                this.visible = val;
            },
            visible(val){
                if(val == false){
                  this.$emit('input', false);
                }
            },
            currentQueryDepartment(){
                let that = this;
                this.departments.map((item)=>{
                    if(item.code != that.currentQueryDepartment.code){
                        item.slidDown = false;
                    }
                })
            },
            currentSelectData(val) {
                console.log(val);
                this.selectedSingle = val;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/selectPerson.vue